import { IonInput } from "@ionic/react";
import React, { useState, useEffect, useRef } from "react";
import { RecommendedExercisesVM } from "../models/RecommendedExercisesVM";
import { GetRecentExerciseSearches } from "../services/ExercisesService";
import { useHistory } from "react-router-dom";
import { ActionType } from "../models/Enums";

interface CustomSearchBarProps {
  exercisesList: RecommendedExercisesVM[];
  clickedOutside: boolean;
  getSelectedExercise: any;
  getSearchText: any;
}

const CustomSearchBar: React.FC<CustomSearchBarProps> = ({
  exercisesList,
  clickedOutside,
  getSelectedExercise,
  getSearchText,
}) => {
  let history = useHistory();

  const [searchText, setSearchText] = useState<string>("");
  const [debouncedSearchText, setDebouncedSearchText] = useState<string>("");
  const [isSearchClicked, setIsSearchClicked] = useState<boolean>(false);
  const [filteredData, setFilteredData] = useState<RecommendedExercisesVM[]>(
    []
  );
  const [exerciseRecentSearches, setExerciseRecentSearches] = useState<any[]>(
    []
  );

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
      getSearchText(searchText);
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);

  // Effect to handle the actual search with debounced text and Filter exercises based on search text
  useEffect(() => {
    if (debouncedSearchText) {
      const filteredExercises = exercisesList.filter((exercise: any) =>
        exercise.testName
          .toLowerCase()
          .includes(debouncedSearchText.toLowerCase())
      );
      if (filteredExercises.length > 3) {
        setFilteredData(filteredExercises.slice(0, 3));
      } else {
        setFilteredData(filteredExercises);
      }
    } else {
      setIsSearchClicked(false);
    }
  }, [debouncedSearchText, exercisesList]);

  const handleExerciseClick = (exercise: any) => {
    setSearchText(exercise.testName);
    getSelectedExercise(exercise);
  };

  const GetRecentExercises = async () => {
    const obj = {};
    try {
      await GetRecentExerciseSearches(obj)
        .then(async function (response: any) {
          setExerciseRecentSearches(response?.data?.recentSearchData);
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
    }
  };

  const handleExerciseSearchBarClick = () => {
    setIsSearchClicked(true);
    GetRecentExercises();
  };

  return (
    <div className="search-exercise-wrap">
      <IonInput
        type="text"
        placeholder="Search Exercise"
        className="search-input-field"
        value={searchText}
        onIonChange={(e) => setSearchText(e.detail.value!)}
        onClick={() => handleExerciseSearchBarClick()}
      ></IonInput>

      {/* Display search results */}
      {debouncedSearchText !== "" &&
        !clickedOutside &&
        (filteredData != null && filteredData.length > 0 ? (
          <div className="search-result">
            <ul>
              {filteredData.map((exercise: any, index) => (
                <li
                  key={index}
                  onClick={() => {
                    handleExerciseClick(exercise);
                  }}
                >
                  {exercise.testName}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="search-result">
            <h6>No Exercises Found</h6>
          </div>
        ))}
      {/* Display recent searches */}
      {debouncedSearchText === "" &&
        exerciseRecentSearches &&
        exerciseRecentSearches.length > 0 &&
        isSearchClicked &&
        !clickedOutside && (
          <div className="search-result">
            <ul>
              {exerciseRecentSearches.map((search: any, index) => (
                <li
                  key={index}
                  onClick={() => {
                    handleExerciseClick(search);
                  }}
                >
                  {search.testName}
                </li>
              ))}
            </ul>
          </div>
        )}
    </div>
  );
};
export default CustomSearchBar;
